module.exports = __webpack_public_path__ + "img/bag.03774b1f.svg";